module.exports = __webpack_public_path__ + "static/img/b.98f1e571.png";